import {BaseModel} from "../../../../infrastructure/models/base-model";
import {BaseRouteMetaDataModel} from "../../../../infrastructure/models/route/base-route.meta-data.model";
import {BaseMatchModel} from "./base-match-model";
import {Type} from "../../../../infrastructure/type";
import {ROUTE_NAMES} from "../../../consts";
import {BaseLinkParams} from "../../../../infrastructure/models/link/base-link-params";

export class BaseRouteConfig extends BaseModel {
  exact: Boolean;
  name: String;
  parent: ROUTE_NAMES;
  path: String;
  paths: Array<String>;
  component: Object;
  metadataType: Type<BaseRouteMetaDataModel>;
  matchType: Type<BaseMatchModel>;
  filters: Object<Array>;
  PlaceholderComponent;
  outbrainId: String = null;
  redirect: String = null;
  scrollToTop: Boolean = true;
  index: Boolean = false;

  constructor() {
    super();

    this.exact = true;
    this.matchType = BaseMatchModel;
  }

  getCanonicalPath(params: BaseLinkParams) {
    return this.path;
  }

  isValidMatch(match: BaseMatchModel, route) {
    if (!this.filters) {
      return route?.config?.parent === match?.parent;
    }

    let isValid: Boolean = true;

    for (const key in match.params) {
      const hasParams = this.filters.params && this.filters.params[key];
      const isValidByParams = hasParams ? this.filters.params[key].includes(match.params[key] || '') : true;

      const hasFunctions = this.filters.functions && this.filters.functions[key];
      const isValidByFunction = hasFunctions ? this.filters.functions[key](match.params[key] || '') : true;

      if(hasParams && hasFunctions) {
        isValid = isValidByParams || isValidByFunction;
      } else if(hasParams && !hasFunctions) {
        isValid = isValidByParams;
      } else if(!hasParams && hasFunctions) {
        isValid = isValidByFunction;
      }

      if(!isValid){
        break;
      }
    }

    return isValid
  }
}
